export default "/images/vendor/flag-icon-css/flags/4x3/bj.svg?e8591ed7d23999de96ef5e714b0fffee";